import { lazy } from "react";
// Utilities
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const ReportsViewLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "planner-reportsview" */ "./ReportsView")).then((page)=>{
        return {
            default: page.ReportsView
        };
    });
export const LazyReportsView = /*#__PURE__*/ lazy(ReportsViewLazyLoader);
